import { Navigate, createFileRoute } from "@tanstack/react-router";
import { stringParam } from "../../../lib/url-state";

/* Production opens on Activity: the floor's day, what went wrong in it and the floor
 * checks. There is no separate overview; an old link to one open check opens it there. */
export const Route = createFileRoute("/_console/production/")({
  validateSearch: (search: Record<string, unknown>) => ({ check: stringParam(search.check) }),
  component: () => {
    const { check } = Route.useSearch();
    return check === undefined ? (
      <Navigate to="/production/activity" replace />
    ) : (
      <Navigate to="/production/activity" search={{ view: "checks", check }} replace />
    );
  },
});
